interface Props {
  blur?: boolean
}

export default function CorporateSavingsSVG({ blur }: Readonly<Props>) {
  return (
    <svg
      role="img"
      aria-label="Hand som lägger pengar i en spargris"
      width="188"
      height="171"
      viewBox="0 0 188 171"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="px-6 py-3 sm:p-0 relative left-8 sm:left-0 -top-8 sm:-top-4"
    >
      <title>Hand som lägger pengar i en spargris</title>
      <path
        d="M74 170.359C114.869 170.359 148 137.228 148 96.3585C148 55.4894 114.869 22.3585 74 22.3585C33.1309 22.3585 0 55.4894 0 96.3585C0 137.228 33.1309 170.359 74 170.359Z"
        fill={blur ? '#E6E6E6' : '#F8F0E8'}
      />
      <path
        d="M133.905 134.133L132.298 121.264C131.824 117.483 128.378 114.812 124.609 115.275L118.03 116.096C113.983 109.17 107.542 103.458 99.5759 99.5033L97.3097 81.3502C97.3097 81.3502 87.4931 84.2408 84.9609 94.5893C78.3356 93.2827 71.2015 93.0052 63.8593 93.9187C41.9368 96.659 24.4081 109.355 18.0371 125.161C14.58 123.438 11.0071 122.871 7.64246 123.484C6.82152 122.49 5.67684 121.461 4.09277 120.628C5.66527 125.172 7.67715 129.508 10.059 133.59C10.4984 131.358 10.3365 128.941 9.51559 126.756C11.5853 126.606 14.0943 126.976 16.8925 128.456C15.609 132.769 15.1581 137.278 15.6553 141.834C29.195 159.189 50.2965 170.358 74.0112 170.358C87.0653 170.358 99.3331 166.959 109.982 161.027C115.463 155.674 119.417 149.384 121.36 142.643L127.939 141.822C131.72 141.348 134.391 137.902 133.928 134.133H133.905Z"
        fill={blur ? '#E6E6E6' : '#FF99AC'}
      />
      <path
        d="M100.039 122.432C102.293 122.432 104.12 120.605 104.12 118.35C104.12 116.096 102.293 114.269 100.039 114.269C97.7844 114.269 95.957 116.096 95.957 118.35C95.957 120.605 97.7844 122.432 100.039 122.432Z"
        fill={blur ? '#E6E6E6' : '#70210D'}
      />
      <path
        d="M73.1603 103.91L46.9727 108.736L47.9574 114.08L74.145 109.255L73.1603 103.91Z"
        fill={blur ? '#E6E6E6' : '#70210D'}
      />
      <path
        d="M57.8579 104.614C65.3804 104.614 71.4786 98.5161 71.4786 90.9937C71.4786 83.4712 65.3804 77.373 57.8579 77.373C50.3355 77.373 44.2373 83.4712 44.2373 90.9937C44.2373 98.5161 50.3355 104.614 57.8579 104.614Z"
        fill={blur ? '#E6E6E6' : '#FFCC33'}
      />
      <path
        d="M86.4864 11.2584C86.4864 11.2584 42.5026 20.9594 36.0276 22.5319C31.1483 23.7112 26.5117 24.9022 26.7892 26.3244C27.6911 30.9609 33.033 32.094 37.4498 31.539C47.6942 30.2556 67.6511 26.9719 72.1836 25.5844C76.8086 20.4622 86.4979 11.2584 86.4979 11.2584H86.4864Z"
        fill={blur ? '#E6E6E6' : '#FFD2A8'}
      />
      <path
        d="M90.4074 11.7326C90.4074 11.7326 57.1305 9.03852 52.4361 8.65695C43.8799 7.95164 46.3311 15.3863 52.5286 16.4385C59.709 17.6526 72.844 19.9998 76.1855 20.0229C80.3711 17.537 90.3958 11.7441 90.3958 11.7441L90.4074 11.7326Z"
        fill={blur ? '#E6E6E6' : '#FFD2A8'}
      />
      <path
        d="M81.3068 12.4725C81.3068 12.4725 39.6587 35.1234 33.9352 38.5459C28.6049 41.7488 22.9277 45.2984 24.0724 47.2872C25.3674 49.5419 29.8884 52.6406 37.034 49.0794C46.2724 44.4659 63.3618 36.8925 67.3624 34.3834C70.4843 28.2437 81.2837 12.4609 81.2837 12.4609L81.3068 12.4725Z"
        fill={blur ? '#E6E6E6' : '#FFD2A8'}
      />
      <path
        d="M109.889 68.6893C106.895 70.0537 95.9797 75.465 87.9784 79.0956C81.8619 81.8706 74.9706 84.4259 73.9069 83.1771C70.9931 79.7893 69.0506 73.7768 79.3644 68.1921C82.5672 66.4578 86.1631 64.9662 94.2684 59.1503C102.906 52.9528 101.761 24.4396 78.8325 35.054C69.3512 39.4478 62.3444 45.6221 58.6791 56.9534C57.3956 60.9193 55.8925 69.9381 49.3944 68.5853C47.1397 68.1112 47.3594 55.2537 48.8972 49.1718C53.1291 32.5103 62.7259 25.3762 78.0116 14.6462C85.8741 9.11933 89.7359 10.079 95.5172 10.9693C101.298 11.8596 125.927 16.9125 132.621 16.6928C139.316 16.4731 146.866 14.785 146.866 14.785C146.866 14.785 153.538 37.7828 154.474 50.1778C132.517 54.4096 112.872 67.325 109.878 68.6778L109.889 68.6893Z"
        fill={blur ? '#E6E6E6' : '#FFD2A8'}
      />
      <path
        d="M151.942 59.6937L187.196 52.5481V0.03125L141.513 11.1659L151.942 59.6937Z"
        fill={blur ? '#E6E6E6' : '#1166BB'}
      />
      <path
        d="M159.099 51.7387C161.501 51.7387 163.447 49.7923 163.447 47.3912C163.447 44.9901 161.501 43.0437 159.099 43.0437C156.698 43.0437 154.752 44.9901 154.752 47.3912C154.752 49.7923 156.698 51.7387 159.099 51.7387Z"
        fill={blur ? '#E6E6E6' : '#FF620F'}
      />
    </svg>
  )
}
